import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { getPedidos } from '../services/pedidos.services';
const usePedidos = (initialState, urlInvoiceApi) => { 
    
    const headersApi = useSelector(state => state.url.headersAPI);
    const idProveedor = useSelector(state => state.auth.IdProveedor);
    const [pedidos, setPedidos] = useState(initialState);

    const getData = async () => {
        const data = await getPedidos({headers: headersApi, idProveedor:idProveedor, urlInvoiceApi: urlInvoiceApi})
        setPedidos(() => data)
    }

    useEffect(() => {
      getData()
    }, [])
    

  return (
    [pedidos]
  )
}

export default usePedidos